require('masonry-layout');

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullScreen from 'lightgallery/plugins/fullscreen'


import lightGallery from 'lightgallery';

let sliders = [];

export function initializeGalleryBlock(reset = false) {
    /*$(".lazy").lazy({
        scrollDirection: 'vertical',
        effect: 'fadeIn',
        visibleOnly: true,
    });*/

    $('.masonry-album').each(function () {
        let self = this;

        let $grid = $(self).masonry({
            percentPosition: true,
            horizontalOrder: true,
        });

        $grid.imagesLoaded().progress(function () {
            $grid.masonry('layout');
        });

    });


    $('.gallery-block').each(function () {
        let self = this;
        lightGallery(self, {
            plugins: [lgThumbnail, lgZoom, lgFullScreen],
            thumbnail: true,
            appendSubHtmlTo: '.lg-item',
            showMaximizeIcon: true,
            hash: false,
            subHtmlSelectorRelative: true,
            download: false,
            licenseKey: 'A5F7F5D4-573E-4C09-A74E-64D3237097D6'
        });
    });

    $('.table-gallery-block').each(function () {
        let self = this;
        lightGallery(self, {
            selector: '.light-image',
            plugins: [lgThumbnail],
            thumbnail: true,
            download: false,
            licenseKey: 'A5F7F5D4-573E-4C09-A74E-64D3237097D6'
        });
    });

    if (reset) {
        $('.inline-gallery-block').each(function () {
            let self = this;
            if ($(self).data('dynamic-elements').length > 0) {

                let lgContainer = document.getElementById(`slider-${$(self).data('block')}`);
                let slider = lightGallery(lgContainer, {
                    galleryId: $(self).data('block'),
                    plugins: [lgThumbnail, lgAutoplay],
                    slideShowAutoplay: $(self).data('slide-auto'),
                    dynamic: true,
                    hash: false,
                    closable: false,
                    showMaximizeIcon: true,
                    container: self,
                    appendSubHtmlTo: '.lg-item',
                    slideDelay: 500,
                    autoplay: true,
                    download: false,
                    dynamicEl: $(self).data('dynamic-elements') || [],
                    licenseKey: 'A5F7F5D4-573E-4C09-A74E-64D3237097D6',
                    selector: 'a',
                });

                setTimeout(function () {
                    slider.openGallery();
                }, 200);
            }

            let zIndex = $('.fixed-top').css('z-index') + 50;
            $(this).css('z-index', zIndex);
        });
    }
}
